const controlCssClass = 'js-textSizer';
const statePropertyName = 'textSizerSize'; // HTML:data-text-sizer-size

export default class TextSizer {
    constructor() {
        document.addEventListener('DOMContentLoaded', this._init.bind(this));
    }

    get size() {
        return window.localStorage.getItem(statePropertyName);
    }
    set size(value) {
        this.targetElement.style.fontSize = value;
        window.localStorage.setItem(statePropertyName, value);
    }

    get targetElement() {
        return document.body;
    }

    _init() {
        const controls = document.getElementsByClassName(controlCssClass);

        if (!controls || !controls.length) {
            return;
        }

        this._applyInitialState();

        for (let i = 0; i < controls.length; i++) {
            const element = controls[i];
            element.addEventListener('click', ((event, element) => {
                const newSize = this._readNewSize(element);
                this.size = newSize;
                return false;
            }).bind(this, event, element));
        }
    }

    _applyInitialState() {
        if (this.size) {
            this.size = this.size; // This should update the DOM.
        }
    }

    _readNewSize(element) {
        return element.dataset[statePropertyName];
    }
}
